export enum QuestionType {
  FIXED_VALUES = 1,
  TEXT = 2,
  NUMBER = 3
}
